<template lang="pug">
.mtutor#members
  .index-list-title
    .en
      | members
      br
      | introduction
    .cn 加入他们 成为他们
  .member-swiper
    swiper(:options="swiperOption" ref="mySwiper")
      swiper-slide(v-for="member, index in members", :key="`member_${index}`")
        .item
          img(:src="member.cover_url")
          .desc
            | {{member.show_name}}
            br
            | <span>{{member.show_company}}</span> {{member.show_duty}}
</template>

<script>
import api from '../../store/api'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'mtutor',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      members: [],
      currentmember: -1,
      swiperOption: {
        slidesPerView: 1,
        slidesPerColumn: 3,
        // slidesPerGroup: 1,
        speed: 1000,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        lazy: {
          loadPrevNext: true,
        }
      }
    }
  },
  computed: {
    cm() {
      return this.currentmember > -1 ? this.members[this.currentmember] : false
    }
  },
  methods: {
    getData () {
      this.loading = true
      api.get(`members?per=100`).then((result) => {
        this.members = result.data.member_manages.reverse()
        this.loading = false
      }).catch((err) => {
        console.log(err.toString())
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="stylus">
.mtutor
  background #000
  color #fff
  padding-top 20px
  .index-list-title
    padding 20px
    .en
      font-family 'BebasNeue'
      font-size 48px
      line-height 1
    .cn
      color #b2916d
      font-size 18px
      line-height 1.5
    h1
      font-family 'FZLTTHCJW--GB1-0'
      line-height 2.2em
  // .member-swiper
  .item
    position relative
    transition all 0.3s
    cursor pointer
    img
      width 100%
      height 100%
      opacity 0.5
      // filter grayscale(100%)
      vertical-align bottom
      transition all 0.3s
    .desc
      // position absolute
      // right 0
      // bottom 0
      text-align right
      padding 0.4em 1.2em 0.3em 0.5em
      margin-bottom 0.5em
      line-height 1.25
      font-size 14px
      span
        color #B2916D
    // &:hover
    //   transform scale(1.05)
    //   z-index 1
    //   img
    //     opacity 1
    //     filter none
    //   .desc
    //     background #000
  .overmember
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    background rgba(0,0,0,0.8)
    z-index 99
    display flex
    justify-content center
    align-items center
    .detail
      position relative
      width 70%
      background #000
      text-align left
      display flex
      align-items center
      .avatar
        width 50%
        img
          width 100%
      .info
        width 50%
        padding 3em 5em
        .name
          font-size 3.6rem
        .company
          font-size 1.2rem
          span
            color $yellow
        .description
          padding-top 3em
          font-size 1.1rem
          line-height 1.5
      img.close
        width 3rem
        position absolute
        right -4em
        top 0
        cursor pointer
</style>



// WEBPACK FOOTER //
// Tutor.vue?6283a686